import {ReactNode} from 'react';
import {Provider} from 'react-redux';
import {store} from '~/common/components/MegaNav/MegaNavVariant/reducers';
import {INIT_APP} from '~/common/fabric/constants';
import {isFabricWebview} from '~/common/utils/webview';
import {getUserData} from '~library/utils/auth/utils';

type MegaNavVariantStoreProviderProps = {
  children: ReactNode;
};

export const MegaNavVariantStoreProvider = ({children}: MegaNavVariantStoreProviderProps) => {
  const isInWebview = isFabricWebview();

  store.dispatch({
    type: INIT_APP,
    payload: {
      user: getUserData(isInWebview),
    },
  });

  return <Provider store={store}>{children}</Provider>;
};
